import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-766913f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "property-header" }
const _hoisted_2 = { class: "field has-addons" }
const _hoisted_3 = { class: "control is-expanded" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = { class: "control" }
const _hoisted_6 = ["onClick", "disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "control" }
const _hoisted_10 = ["onClick", "disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "control" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StylesheetEditor = _resolveComponent("StylesheetEditor")!
  const _component_PanelAttribute = _resolveComponent("PanelAttribute")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Themes" }, {
    default: _withCtx(() => [
      _createVNode(_component_PanelAttribute, {
        title: "Themes",
        expandable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pkgData.themes, (theme, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "property",
              key: i
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input is-small",
                      type: "text",
                      placeholder: "Key",
                      "onUpdate:modelValue": ($event: any) => ((theme.name) = $event)
                    }, null, 8, _hoisted_4), [
                      [_vModelText, theme.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "button is-small",
                      onClick: ($event: any) => (_ctx.up(i)),
                      disabled: _ctx.isUpDisabled(i)
                    }, _hoisted_8, 8, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "button is-small",
                      onClick: ($event: any) => (_ctx.down(i)),
                      disabled: _ctx.isDownDisabled(i)
                    }, _hoisted_12, 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "button is-small",
                      onClick: ($event: any) => (_ctx.remove(i))
                    }, _hoisted_16, 8, _hoisted_14)
                  ])
                ])
              ]),
              _createVNode(_component_StylesheetEditor, {
                modelValue: theme.stylesheet,
                "onUpdate:modelValue": ($event: any) => ((theme.stylesheet) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]))
          }), 128)),
          _createElementVNode("button", {
            class: "button is-small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add()))
          }, "Add theme")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}